import $ from 'jquery';
import Mustache from 'mustache';

var validDateTime = /[0-9]{4}-[0-1][0-9]-[0-3][0-9] [0-2][0-9]:[0-5][0-9]:[0-5][0-9]/,
	maxNumListItems = 9, // Maximum number of items on a list
	entriesData, // Entries fetched from the server
	syncing = {},
	lastSync = 0,
	currentTurnaround = {
		arrTime: null,
		depTime: null
	},
	supportsNumberInput = Modernizr.inputtypes.number,
	DTable,
	clientJSVersion = 1517382838099;

window.localEntries = localStorage.getItem(window.userId) ? JSON.parse(localStorage.getItem(window.userId)) : {};

var serviceCard = {

	init: function() {

		/***
		 * Do things when field value is changed
		 * (and when document loads)
		 ***/
		switchView();

		if (Modernizr.inputtypes.time) {
			$('body').addClass('supports-time-input');
		}

		$('#sync-button').click(syncAllFields);
		setInterval(syncAllFields, 1000 * 15);

		$('.delete-turnaround').click(function() {
			$(this).nextAll('.delete-turnaround-confirm-container').show();
			$(this).hide();
		});
		$('.delete-turnaround-cancel').click(function() {
			$(this).closest('.delete-turnaround-confirm-container').hide()
				.prevAll('.delete-turnaround').show();
		});
		$('.delete-turnaround-confirm').click(function() {
			deleteTurnaround($(this).data('turnaround') || $('#field-turnaround').val());
		});

		setInterval(updateFlightTimes, 60000);

		setInterval(updateNils, 60000);
		updateNils();

		// Sync when field is edited
		$('body').on('change paste', '.field', function() {
			if ($(this).is('input[type="radio"]')) {
				updateFieldValues($('input[type="radio"][name="' + $(this).attr('name') + '"]'));
			} else {
				updateFieldValues($(this));
			}
		});

		$('body').on('focus', '.field', function() {
			var $field = $(this);
			if (!$field.data('change-time')) {
				$field.data('change-time', Date.now());
				$field.data('change-value', $field.data('current-value'));
			}
		});

		$('body').on('blur', '.field', function() {
			var $field = $(this);
			// value was not changed while in focus
			if ($field.data('change-value') == $field.data('current-value')) {
				$field.data('change-time', false);
				$field.data('change-value', false);
			}
		});

		$('body').on('input', 'input[type="number"]', function() {
			if (this.value.search(/^\d+$/) == -1) {
				this.value = this.value.replace(/\D/g, '');
			}
		});

		$('select[name="apt"]').change(function() {
			var apt = $(this).val();
			location.search = '?apt=' + apt;
		});

		// Confirm leaving page when syncing/offline (in case of unsaved changes)
		$(window).on('beforeunload', function() {
			if ($('body').hasClass('syncing') || $('body').hasClass('offline')) {
				return 'Warning: Data is being synchronized, there might be unsaved changes. Are you sure you want to leave this page?';
			}
		});

		// default view set
		if (typeof defaultView !== 'undefined' && defaultView) {
			$('input[name="fields-filter"][value="' + defaultView + '"]').click();
		}

		/***
		 * Number input increase and decrease buttons
		 ***/
		$('body').on('click', '.increase-number[data-target], .decrease-number[data-target]', function() {
			var $target = $($(this).data('target')),
				oldValue;

			// don't send immediately, wait 500 ms after click
			if ($target.data('timeout')) {
				window.clearTimeout($target.data('timeout'));
				$target.data('timeout', false);
			}
			if (!$target.data('change-time')) {
				$target.data('change-time', Date.now());
			}

			if ($(this).hasClass('increase-number')) {
				try {
					$target[0].stepUp(1);
				} catch (e) { // IE9 fallback
					oldValue = $target.val() || 0;
					if (isNaN(oldValue)) {
						oldValue = 0;
					}
					$target.val(parseInt(oldValue) + 1);
				}
			} else {
				try {
					$target[0].stepDown(1);
				} catch (e) { // IE9 fallback
					oldValue = $target.val() || 0;
					if (isNaN(oldValue)) {
						oldValue = 0;
					}
					$target.val(parseInt(oldValue) - 1);
				}
			}
			$target.data(
				'timeout',
				window.setTimeout(
					function() {
						$target.change();
						$target.data('timeout', false);
					},
					500
				)
			);

		});

		//User log
		var userLogsTemplate = $('#user-logs-template').html();
		$('#user-logs').click(function(e){
			e.preventDefault();

			var logs = { 'synced': [], 'offline': [] };

			function addOfflineEntries() {
				var entries = window.localEntries;
				for(var f in entries) {
					var entry = entries[f];
					for(e in entry) {
						var data = entry[e];
						data.turnaroundInfo = window.turnarounds[ data.turnaround ];
						logs.offline.push(data);
					}
				}
			}
			function renderUserLogs() {
				addOfflineEntries();
				console.log(logs);
				$('.user-log').addClass('active');
				var userLogsHtml = Mustache.render(userLogsTemplate, logs);
				$('.user-log .wrapper').html(userLogsHtml);

				$('.user-log .close').click(function(e){
					e.preventDefault();
					$('.user-log').removeClass('active');
				});
			}

			$.ajax({
				url: '/stage-ajax/userEntries?user=' + userId
			}).done(function(data) {
				logs.synced = data;
				renderUserLogs();
			}).fail(function(){
				renderUserLogs();
			});

		});

		/***
		 * Timestamp
		 ***/

		//Add zero to timestamps
		function addZero(i) {
			if (i < 10) {
				i = '0' + i;
			}
			return i;
		}


		//Returns timestamp in the format the datetime-local field requires it
		function returnTimestamp(timestampValue) {
			var timestamp = typeof timestampValue !== 'undefined' ? timestampValue : '';
			var date = new Date(),
				day = date.getDate(),
				month = date.getMonth() + 1,
				year = date.getFullYear(),
				hours = date.getHours(),
				minutes = date.getMinutes(),
				seconds = date.getSeconds();
			return timestamp = year + '-' + addZero(month) + '-' + addZero(day) + 'T' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds);
		}

		$('body').on('click', 'input[type=date]', function() {
			var $input = $(this);
			if ($input.val() == '') {
				//console.log($input.val());
				$input.val(returnTimestamp().split('T')[0]);
			}
		});

		$('body').on('click', 'input[type=time]', function() {
			var $input = $(this);
			if ($input.val() == '') {

				var date = new Date(),
					hours = date.getHours(),
					minutes = date.getMinutes();
				$input.val(addZero(hours) + ':' + addZero(minutes));
			}
			if ($input.prev().val() == '') {
				//console.log($input.prev());
				$input.prev().val(returnTimestamp().split('T')[0]);
			}

		});



		// Set timestamp
		$('body').on('click', '.timestamp-set', function() {
			var $timestampContainer = $(this).closest('.timestamp-container');
			var $target = $($timestampContainer.data('target'));
			var value = $(this).val();
			var timestamp;

			console.log('timestmap value: ' + value);

			//Remove editing mode
			$timestampContainer.removeClass('editing');
			stopSync($('body'));

			// Set relative timestamp
			if (value.substring(0, 1) === '+' || value.substring(0, 1) === '-') {
				timestamp = new Date(
					Date.now() +
					// we want local time on client, converted to UTC on server
					(new Date().getTimezoneOffset() * -1 * 60 * 1000) +
					($(this).val() * 60 * 1000)
				).setUTCSeconds(0);
			}

			// Set timestamp from input
			else if (value.substring(0, 1) === '#') {

				var $timestampChange = $(this).parent();
				//console.log( 'actual timestamp: ' + $timestampChange.children('.timestamp-timesetter').val() );
				var dateInput = $timestampChange.children('.timestamp-datesetter').val();
				var timeInput = $timestampChange.children('.timestamp-timesetter').val();
				var hourInput = $timestampChange.children('.timestamp-hours').val();
				var minuteInput = $timestampChange.children('.timestamp-minutes').val();

				if (!timeInput && hourInput && minuteInput) {
					timeInput = hourInput + ':' + minuteInput;
					$timestampChange.children('.timestamp-timesetter').val(timeInput);
				}

				$('.timestamp-hours, .timestamp-minutes').change(function(){
					if($(this).parent().find('.timestamp-hours').val() && $(this).parent().find('.timestamp-minutes').val()){
						$timestampChange.children('.timestamp-timesetter').val($(this).parent().find('.timestamp-hours').val() + ':' + $(this).parent().find('.timestamp-minutes').val());
					} else if (!$(this).parent().find('.timestamp-hours').val() && $(this).parent().find('.timestamp-minutes').val()) {
						$timestampChange.children('.timestamp-timesetter').val('00:' + $(this).parent().find('.timestamp-minutes').val());
					} else if($(this).parent().find('.timestamp-hours').val() && !$(this).parent().find('.timestamp-minutes').val()) {
						$timestampChange.children('.timestamp-timesetter').val($(this).parent().find('.timestamp-hours').val() + ':00');
					}
				});

				//console.log('set timestamp: ' + dateInput + ' ' + timeInput);

				var date_year = dateInput.split('-')[0],
					date_month = parseInt(dateInput.split('-')[1]) - 1,
					date_day = dateInput.split('-')[2],
					date_hour = timeInput.split(':')[0],
					date_minute = timeInput.split(':')[1];

				console.log( date_year, date_month, date_day, date_hour, date_minute );


				//var date = new Date(dateInput + ' ' + timeInput);
				//var date = new Date(date_year+'-'+date_month+'-'+date_day+' '+date_hour+':'+date_minute);
				var date = new Date(date_year, date_month, date_day, date_hour, date_minute);

				console.log(date);

				var day = date.getDate();
				//var month = date.getMonth() + 1;
				var month = date.getMonth()+1;
				var year = date.getFullYear();
				var hours = date.getHours();
				var minutes = date.getMinutes();
				var seconds = date.getSeconds();


				console.log('month: ' + month);


				timestamp = year + '-' + addZero(month) + '-' + addZero(day) + ' ' + addZero(hours) + ':' + addZero(minutes) + ':' + addZero(seconds);
				console.log('from input: ' + timestamp);
			}
			// Set absolute timestamp
			else {
				timestamp = value;
			}
			$target.data('change-time', Date.now());
			setValue($target, timestamp);
			updateFieldValues($target);
			//startSync($('body'));
		});

		// Change timestamp freely
		$('body').on('click', '.timestamp-view-change', function() {
			var $timestampContainer = $(this).parents('.timestamp-container');

			// Update hours and minutes inputs
			var currentValue = getValue($($($timestampContainer).data('target')));

			if(currentValue){
				var date_year = currentValue.split(' ')[0].split('-')[0],
					date_month = parseInt(currentValue.split(' ')[0].split('-')[1]) - 1,
					date_day = currentValue.split(' ')[0].split('-')[2],
					date_hour = currentValue.split(' ')[1].split(':')[0],
					date_minute = currentValue.split(' ')[1].split(':')[1];
			}
			//currentValue = !currentValue ? new Date() : new Date(currentValue);
			currentValue = !currentValue ? new Date() : new Date(date_year, date_month, date_day, date_hour, date_minute);

			var date = currentValue;
			var day = date.getDate();
			var month = date.getMonth() + 1;
			//var month = date.getMonth();
			var year = date.getFullYear();
			var hours = date.getHours();
			var minutes = date.getMinutes();
			var seconds = date.getSeconds();

			var timestampDate = year + '-' + addZero(month) + '-' + addZero(day);
			var timestampTime = addZero(hours) + ':' + addZero(minutes);

			$timestampContainer.children('.timestamp-change').children('.timestamp-datesetter').val(timestampDate);
			$timestampContainer.children('.timestamp-change').children('.timestamp-timesetter').val(timestampTime);

			/*
			$timestampContainer.children('.timestamp-change').children('.timestamp-hours').val(currentValue.getUTCHours());
			$timestampContainer.children('.timestamp-change').children('.timestamp-minutes').val(currentValue.getUTCMinutes());
			$timestampContainer.children('.timestamp-change').children('.timestamp-timesetter').val(currentValue.getUTCHours() + ':' + currentValue.getUTCMinutes());
			*/

			$timestampContainer.addClass('editing');

			// Hide timestamp quick setter and view, show timestamp change
			$timestampContainer.children('.timestamp-setter').hide();
			$timestampContainer.children('.timestamp-change').show();
			$timestampContainer.children('.timestamp-view').hide();
		});


		/***
		 * Fields list
		 ***/
		// Add item
		$('.fields-list-add-button').click(function() {

			var
				$t = $(this),
				$list = $t.closest('.fields-list'),
				$nil = $list.find('.nil-setter input'),
				$fieldsListAdd = $t.closest('.fields-list-add'),
				$fieldsListRows = $fieldsListAdd.siblings('.fields-list-rows'),
				$emptyRow = $fieldsListRows.find('.empty-row');

			$t.prop('disabled', true);
			// If another item is being edited, save it
			$('.fields-list-cancel-button').click(); // Cancel row deletion
			//$('.fields-list-save-button').click(); // Save row

			if ($emptyRow.length > 0) {
				$emptyRow = $emptyRow.filter(':first');
				$emptyRow.removeClass('empty-row');

				var values = [];
				$fieldsListAdd.find('.field').each(function() {
					// If this is a timestamp, save add-rows timestamps now
					var $timestampContainer = $(this).closest('.timestamp-container');
					if ($timestampContainer.length > 0) {
						$timestampContainer.find('.timestamp-view-save').click();
					}
					values.push(getValue($(this)));
				});
				$emptyRow.find('.field').each(function() {
					setValue($(this), values.shift());
					//updateFieldValues($(this));
					$(this).prop('disabled', true);
				});

				// Update row uuids
				updateListRows($(this).closest('.fields-list'));

				// Empty values in Add-row
				$fieldsListAdd.find('.field').each(function() {
					setValue($(this), '');
					// If this is a timestamp, put it back to quick set mode
					var $timestampContainer = $(this).closest('.timestamp-container');
					if ($timestampContainer.length > 0) {
						updateTimestampView($timestampContainer);
					}
				});
			}

			updateListValues($list);

			//$list.find('.fields-list-row:not(.empty-row) .fields-list-edit-button').click();
			//$list.find('.fields-list-row:not(.empty-row) .fields-list-save-button').click();

			$nil.prop('disabled', true).prop('checked', false).change(); // If NIL was checked, uncheck it and trigger change
			$t.prop('disabled', false);
		});
		// Edit item
		$('.fields-list-list').on('click', '.fields-list-edit-button', function() {
			// If another item is being edited, save it
			$('.fields-list-cancel-button').click();
			//$('.fields-list-save-button').click();

			var $fieldsListItem = $(this).closest('.fields-list-row');

			$fieldsListItem.parent().parent().parent().addClass('editing');

			$fieldsListItem.find('.field').each(function() {
				$(this).prop('disabled', false);
			});
			$fieldsListItem.find('.fields-list-edit-button').removeClass('fields-list-edit-button').addClass('fields-list-save-button').html(STAGE_TRANSLATION.SAVE);
			$fieldsListItem.find('.fields-list-save-button').after('<button class="fields-list-delete-button">Delete</button>');

			$fieldsListItem.find('.timestamp-view-change').click();
		});
		// Save item
		$('.fields-list-list').on('click', '.fields-list-save-button', function() {
			$(this).removeClass('editing');
			initiateListRowState($(this).closest('.fields-list-row'));
			updateListValues($(this).closest('.fields-list'));
		});

		function deleteListItem(entries) {
			$.ajax('/stage-ajax/deleteListEntries/', {
				data: entries,
				success: function(data) {
					//initiateAllEntries();
					if (!window.location.origin) {
						window.location.origin = window.location.protocol + '//'
						  + window.location.hostname
						  + (window.location.port ? ':' + window.location.port : '');
					}

					var url = document.location.origin + '/en/?turnaround=' + $('#field-turnaround').val();
					//console.log( url );
					document.location = window.location.origin + '/en/?turnaround=' + $('#field-turnaround').val();
				},
				error: function(jqXHR) {
					showNotification(jqXHR.responseText);
				}
			});
		}

		// Delete item
		$('.fields-list-list').on('click', '.fields-list-delete-button', function() {


			var
				$t = $(this),
				$fieldsListRow = $t.closest('.fields-list-row'),
				$list = $t.closest('.fields-list'),
				$nil = $list.find('.nil-setter input');

			// Actually delete item
			if ($(this).hasClass('fields-list-confirm')) {

				var entryUuids = [];

				//stopSync($('body'));
				stopSync($('body'));

				//$fieldsListRow.hide();
				$fieldsListRow.find('.fields-list-col').each(function(){
					var entryUuid = $(this).find('input, select').data('uuid');
					if (typeof entryUuid !== 'undefined') {
						entryUuids.push(entryUuid);
					}
					$(this).find('input, select').val('');
				});

				deleteListItem( { entries: entryUuids, turnaround: $('#field-turnaround').val() } );

				$fieldsListRow = $(this).closest('.fields-list-row');
				$fieldsListRow.addClass('empty-row');
				//updateListValues($list);

				$fieldsListRow.find('.fields-list-cancel-button').removeClass('fields-list-cancel-button').addClass('fields-list-edit-button').html(STAGE_TRANSLATION.EDIT);
				$fieldsListRow.find('.fields-list-delete-button').remove();

				// Update row uuids
				//updateListRows($fieldsListRow.closest('.fields-list'));

				if ($list.find('.fields-list-row').not('.empty-row').length === 0) {
					$nil.prop('disabled', false);
				}

			}
			// Ask for confirmation
			else {
				$(this).addClass('fields-list-confirm').html(STAGE_TRANSLATION.CONFIRM_DELETION);
				$(this).prev('.fields-list-save-button').removeClass('fields-list-save-button').addClass('fields-list-cancel-button').html(STAGE_TRANSLATION.CANCEL);
			}
		});

		// Cancel deletion
		$('.fields-list-list').on('click', '.fields-list-cancel-button', function() {
			$(this).removeClass('fields-list-cancel-button').addClass('fields-list-save-button').html(STAGE_TRANSLATION.SAVE);
			$(this).next('.fields-list-delete-button').removeClass('fields-list-confirm').html(STAGE_TRANSLATION.DELETE);
		});

		// (un)set NIL
		$('label.nil-setter input[type="checkbox"]').change(function() {
			var
				$t = $(this),
				$list = $t.closest('.fields-list'),
				data = {
					list: $list.attr('data-uuid'),
					turnaround: $('#field-turnaround').val(),
					clientJSVersion: clientJSVersion,
					'stage-language': 'en'
				},
				method = $t.prop('checked') ? 'POST' : 'DELETE';

			// check the list is empty
			if ($t.prop('checked') && $list.find('.fields-list-row').not('.empty-row').length) {
				$t.prop('disabled', true).prop('checked', false); // should have already been
				return false;
			}

			$.ajax('/stage-ajax/nil/', {
				method: method,
				data: data,
				success: function(data) {
					disableNilLists();
				},
				error: function(jqXHR) {
					showNotification(jqXHR.responseText);
				}
			});
		});


		// Send create flights form
		$('#create-flights-submit').click(function() {
			createFlights();
		});



		/**
		 * User settings
		 */

		$('.section-header .username').click(function() {
			$('#user-settings').slideToggle();
		});

		$('#user-settings form').submit(function(evt) {
			evt.preventDefault();
			var
				$t = $(this),
				pw = $t.find('[name="new_password"]').val(),
				pwv = $t.find('[name="new_password_verification"]').val(),
				error = [];

			if (pw || pwv) { // check password
				if (pw.length < 8) {
					error.push('password must be at least 8 characters');
				}
				if (pw.search(/\d/) == -1) {
					error.push('password must containt at least one number');
				}
				if (pw.search(/[\,\.\;\:\-\+\!\?\@\#\%\&]/) == -1) {
					error.push('password must containt at least one special character: , . ; : - + ! ? @ # % &');
				}
				if (pw !== pwv) {
					error.push('password and verification do not match');
				}
				if (error.length) {
					showNotification(error.join('\nand\n'));
					return;
				}
			}
			if (error.length < 1) {
				$.post({
					url: '/stage-ajax/userSettings',
					data: $t.serialize(),
					success: function() {
						$('.section-header .username').click();
					},
					error: function(jqXHR) {
						showNotification(jqXHR.responseText);
					}
				});
			}
		});

		if (document.location.search.indexOf('turnaround') > -1) {
			console.log('turnaround found in url');
			$('select#field-turnaround option[value="' + querystringToObj('turnaround') + '"]').attr('selected', 'selected');
			selectTurnaround();
		}

		function initiateAllEntries() {
			// Clear previous values
			entriesData = {};
			setValue($('.field:not(#field-turnaround):not([name="fields-filter"])'), '');
			setListValues($('.fields-list'), []);

			// Empty lists
			$('.fields-list-row').addClass('empty-row');

			// Fetch new value from server
			var data = {
				turnaround: $('#field-turnaround').val(),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			if (typeof data.turnaround === 'undefined' || data.turnaround === '' || data.turnaround === 'turnaround_not_on_list') {
				// No turnaround selected.
				return false;
			}

			startSync($('body'));
			$.get('/stage-ajax/entries', data).done(function(serverData) {
				entriesData = serverData;
				var listData = {};

				// Update all fields that got a value from the server
				for (var uuid in entriesData) {
					if (!entriesData.hasOwnProperty(uuid)) {
						// Property of the prototype - not actual data
						continue;
					}

					var serverValue = entriesData[uuid].value;
					if (serverValue === '') {
						setValue($field, '');
						// Value is empty. Nothing to see here.
						continue;
					}
					var $field = $('[data-uuid="' + uuid + '"]');
					if ($field.length < 1) {
						// Field not found.
						console.log(uuid + ' not found.');
						continue;
					}

					if ($field.closest('.fields-list').length > 0) {
						// This field is in a list. Save it for later - lists are handled separately.
						var listId = $field.closest('.fields-list').data('uuid');
						var listFieldCol = $field.closest('.fields-list-col').prevAll().length;
						var listFieldRow = $field.closest('.fields-list-row').prevAll().length;
						if (typeof listData[listId] === 'undefined') {
							listData[listId] = {
								timestamp: entriesData[uuid].timestamp,
								user: entriesData[uuid].user,
								values: [],
								entryUuid: []
							};
						}
						if (typeof listData[listId].values[listFieldRow] === 'undefined') {
							listData[listId].values[listFieldRow] = [];
							listData[listId].entryUuid[listFieldRow] = [];
						}
						listData[listId].values[listFieldRow][listFieldCol] = serverValue;
						listData[listId].entryUuid[listFieldRow][listFieldCol] = entriesData[uuid].entryUuid;


						continue;
					}

					var $timestampContainer = $field.closest('.timestamp-container');
					if ($timestampContainer.length > 0) {
						// This is a timestamp type of field. Convert datetime string to unix timestamp.
						//var datetime = serverValue.split(/[-: ]/);
						//serverValue = Date.UTC(datetime[0], datetime[1], datetime[2], datetime[3], datetime[4], datetime[5]);
						//I'm not sure why we should use unix timestamp here when we dont use it anywhere else
					}

					setValue($field, serverValue, entriesData[uuid].entryUuid);
				}

				// Handle lists
				$.each(listData, function(listId, list) {
					var $list = $('[data-uuid="' + listId + '"]');

					if ($list.length < 1) {
						// List not found.
						console.log(listId + ' not found.');
						return true; // Continue $.each
					}
					console.log('value: ' + list.values + ' entryUuid: ' + list.entryUuid);
					setListValues($list, list.values, list.entryUuid);
					initiateListState($list);

					//$list.find('.fields-list-row:not(.empty-row) .fields-list-edit-button').click();
					//$list.find('.fields-list-row:not(.empty-row) .fields-list-save-button').click();
				});

				//console.log('iniateAllEntries');
				updateTimestampView();
				checkAircraftType();

				stopSync($('body'));

			}).fail(function(jqXHR, textStatus, errorThrown) {

				if (jqXHR.status == 403) {
					showNotification('Please refresh page, your session has expired');
				}

				if (jqXHR.status !== 200) {
					startOffline();
					stopSync($('body'));
				}
			});

		}

		function syncAllFields() {

			if ((new Date() - lastSync) / 1000 < 5) {
				// It's been less than 5 seconds since last sync. Don't sync again.
				console.log('Its been less than 5 seconds since last sync. Dont sync again.');
				return;
			}

			//With the new timestamps this will break syncing.
			/*if ($('.timestamp-change .timestamp-set:visible').length > 0) {
				// The user is editing a timestamp. Don't sync, it will mess everything up.
				console.log('The user is editing a timestamp. Dont sync, it will mess everything up.');
				return;
			}*/


			lastSync = new Date();
			//console.log('sync now: ' + lastSync);

			var data = {
				turnaround: $('#field-turnaround').val(),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			if (typeof data.turnaround === 'undefined' || data.turnaround === '' || data.turnaround === 'turnaround_not_on_list') {
				// No turnaround selected.
				console.log('No turnaround selected')
				return false;
			}

			// Check if there are any fields that failed to update and try again
			var offlineEdits = false;

			$('.field.offline').each(function() {
				updateFieldValues($(this));
				offlineEdits = true;
			});
			$('.fields-list.offline').each(function() {
				updateListValues($(this));
				offlineEdits = true;
			});

			startSync($('body'));

			//console.log( 'offlineEdits: ' + offlineEdits );
			if (!offlineEdits) {

				$.get('/stage-ajax/entries', data).done(function(serverData) {
					entriesData = serverData;
					var listData = {};

						// Update all fields that got a value from the server
					for (var uuid in entriesData) {
						if (!entriesData.hasOwnProperty(uuid)) {
								// Property of the prototype - not actual data
							continue;
						}

						var serverValue = entriesData[uuid].value;

						var $field = $('[data-uuid="' + uuid + '"]');
						if ($field.length < 1) {
								// Field not found.
							console.log(uuid + ' not found.');
							continue;
						}

						if ($field.closest('.fields-list').length > 0) {
								// This field is in a list. Save it for later - lists are handled separately.
							var listId = $field.closest('.fields-list').data('uuid');
							var listFieldCol = $field.closest('.fields-list-col').prevAll().length;
							var listFieldRow = $field.closest('.fields-list-row').prevAll().length;
							if (typeof listData[listId] === 'undefined') {
								listData[listId] = {
									timestamp: entriesData[uuid].timestamp,
									user: entriesData[uuid].user,
									values: [],
									entryUuid: []
								};
							}
							if (typeof listData[listId].values[listFieldRow] === 'undefined') {
								listData[listId].values[listFieldRow] = [];
								listData[listId].entryUuid[listFieldRow] = [];
							}
							listData[listId].values[listFieldRow][listFieldCol] = serverValue;
							listData[listId].entryUuid[listFieldRow][listFieldCol] = entriesData[uuid].entryUuid;

							continue;
						}

						if (fieldIsBeingEdited($field)) {
								// Field is being edited. Don't sync it this time.
								// TODO: handle possible conflicts
							continue;
						}

						var $timestampContainer = $field.closest('.timestamp-container');
						if ($timestampContainer.length > 0) {
								// This is a timestamp type of field.

							if (serverValue !== '') {
									// Convert datetime string to unix timestamp.
									//var datetime = serverValue.split(/[-: ]/);
									// month value below is between 0... 11, hence prefix decrement of month
									//serverValue = Date.UTC(datetime[0], --datetime[1], datetime[2], datetime[3], datetime[4], datetime[5]);
							}
						}
							//console.log('field uuid: ' + uuid + ' serverValue: ' + serverValue);
						setValue($field, serverValue, entriesData[uuid].entryUuid);
					}

						// Handle lists
					$.each(listData, function(listId, list) {
						var $list = $('[data-uuid="' + listId + '"]');

						if ($list.length < 1) {
								// List not found.
							console.log(listId + ' not found.');
							return true; // Continue $.each
						}

						setListValues($list, list.values, list.entryUuid);
						initiateListState($list);

							//$list.find('.fields-list-row:not(.empty-row) .fields-list-edit-button').click();
							//$list.find('.fields-list-row:not(.empty-row) .fields-list-save-button').click();
					});

						//console.log('syncAllFields');
					updateTimestampView();
					checkAircraftType();

					stopSync($('body'));
				})
					.fail(function(jqXHR, textStatus, errorThrown) {
						if (jqXHR.status == 403) {
							showNotification('Please refresh page, your session has expired');
						}

						if (jqXHR.status !== 200) {
							startOffline();
							stopSync($('body'));
						}
					});
			} else {
				stopSync($('body'));
			}
		}

		function listIsBeingEdited($list) {
			var isBeingEdited = false;
			$list.find('.field').each(function() {
				if (fieldIsBeingEdited($(this))) {
					isBeingEdited = true;
					return false;
				}
			});
			return isBeingEdited;
		}

		function fieldIsBeingEdited($field) {
			if ($field.is(':focus') || $field.data('timeout')) {
				return true;
			}
			var $timestampContainer = $field.closest('.timestamp-container');
			if ($timestampContainer.length > 0) {
				// This is a timestamp type of field.
				if ($timestampContainer.find('.timestamp-change').is(':visible')) {
					// Timestamp is being edited.
					return true;
				}
			}
			var $fieldsListRow = $field.closest('.fields-list-row');
			if ($fieldsListRow.length > 0) {
				// This is a field in a list.
				if ($fieldsListRow.find('.fields-list-edit-button').length < 1) {
					// There's no edit button. This means that the row is being edited. Don't sync at this time.
					return true;
				}
			}

			return false;
		}

		/***
		 * Select turnaround
		 ***/
		function selectTurnaround() {
			$('#create-flights').hide();
			$('#create-flights .error').empty();

			var turnaround = $('#field-turnaround').val();
			var $turnaroundDetails = $('#turnaround-details');
			// turnarounds is set in Stage HTML element 'Sections / Turnaround selection'
			if (typeof turnarounds[turnaround] !== 'undefined') {
				var turnaroundInfo = turnarounds[turnaround];

				// Put turnaroundInfo's properties into $turnaroundDetails's children
				for (var prop in turnaroundInfo) {
					if (turnaroundInfo.hasOwnProperty(prop)) {
						var formattedValue = turnaroundInfo[prop],
							dt;
						// Format datetime to hh:mm
						if (typeof formattedValue === 'string' && formattedValue.match(validDateTime) !== null) {
							dt = new Date(formattedValue.substring(0, 16).replace(/(\d) (\d)/, '$1T$2') + 'Z');
							dt.setTime(dt.getTime() + (new Date().getTimezoneOffset() * -1 * 60 * 1000));
							formattedValue = dt.toISOString().substring(11, 16);
						}
						$turnaroundDetails.find('[data-property=' + prop + ']').html(formattedValue);
					}
				}
				$('.section-fields').show();

				// If at least one of the turnarounds flights is ad hoc, show delete turnaround button
				$('.delete-turnaround').toggle(turnaroundInfo.arr_ad_hoc === '1' ||  turnaroundInfo.dep_ad_hoc === '1');
				$('.delete-turnaround-confirm-container').hide();

				// Update fields
				initiateAllEntries();
				updateNils();
				updateFlightTimes();

				/***
				 * TODO: what to do if there's unsaved information in the fields and
				 * turnaround is changed? Attempt to save unsaved data, or ask user?
				 ***/
			} else {
				$turnaroundDetails.find('[data-property]').html('');
				$('.section-fields').hide();

				if (turnaround === 'turnaround_not_on_list') {
					// Open create flights form
					$('#create-flights').show();
				}
			}
		}

		/***
		 * Delete turnaround
		 ***/
		function deleteTurnaround(turnaround) {
			var data = {
				turnaround: turnaround,
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			$.ajax('/stage-ajax/deleteTurnaround/', {
				method: 'DELETE',
				data: data,
				success: function(data) {
					$('#field-turnaround').val('').change();
					$('.delete-turnaround-confirm-container').hide();

					// Remove turnaround from turnarounds list
					$('#field-turnaround').children('[value="' + turnaround + '"]').remove();

					var $turnaround = $('tr[data-turnaround="' + turnaround + '"]');
					$turnaround.fadeOut(5000, function() {
						$turnaround.remove();
					});
				},
				error: function(jqXHR) {
					showNotification(jqXHR.responseText);
				}
			});
		}

		/***
		 * Switch view
		 ***/
		function switchView() {
			var viewUuid = $('input[name="fields-filter"]:checked').val();
			if (typeof viewUuid !== 'undefined') {
				// Find view information from views variable that is set in Stage.
				var view;
				for (var i = 0; i < views.length; i++) {
					if (views[i].uuid === viewUuid) {
						view = views[i];
						break;
					}
				}
				if (typeof view !== 'undefined') {
					// View has been found. Let's get down to business

					// Move all fields to a hidden container
					$('.section-fields .field-container').appendTo('#hidden-fields');

					// Remove all empty sections
					$('.section-fields').each(function() {
						if ($(this).children('div').length < 1) {
							$(this).remove();
						}
					});

					// Loop through each group
					for (var j = 0; j < view.groups.length; j++) {
						var $section;
						// If there's only one group, just put the fields in same section with the view filters
						if (view.groups.length < 2) {
							$section = $('.section-fields');
						}
						// If there's more than one group, create a section for each and add the groups title
						else {
							$section = $('<section></section>');
							$section.addClass('section-fields');
							if (view.groups[j].title !== false) {
								$section.append('<h3>' + view.groups[j].title + '</h3>');
							}
						}

						// Loop through each field in this group and add it to the section
						for (var k = 0; k < view.groups[j].attributes.length; k++) {
							var attribute = view.groups[j].attributes[k];
							$('#hidden-fields [data-uuid=' + attribute + ']').closest('.field-container').appendTo($section);
						}

						// Add newly created section into dom
						if ($section.parent().length < 1) {
							$section.insertBefore('#hidden-fields');
						}
					}

					if ($('#field-turnaround').val() !== '') {
						$('.section-fields').show();
					}
				}
			}

			checkAircraftType();
		}

		/***
		 * Update field values and value history
		 ***/
		function updateFieldValues($field) {
			if ($field.attr('id') === 'field-turnaround') {
				selectTurnaround();
			} else if ($field.attr('name') === 'fields-filter') {
				switchView();
			} else if (typeof $field.data('uuid') !== 'undefined') {
				$field.data('last-value', $field.data('current-value'));
				$field.data('current-value', getValue($field));

				if ($field.data('last-value') !== $field.data('current-value') || $field.hasClass('offline')) {
					// Value has changed. Update entry.

					// Save entry to database
					if ($field.closest('.fields-list').length === 0) {
						updateEntry($field);
					}

					// If timestamp, update timestamp stuff
					var $timestampContainer = $field.parents('.timestamp-container');
					if ($field.attr('type') === 'hidden' && $timestampContainer.length) {
						//console.log('updateFieldValues');
						updateTimestampView($timestampContainer);
					}
				}

				checkAircraftType();
			}
		}

		function initiateListState($list) {

			if ($list.hasClass('editing')) {
				return;
			}

			$list.find('.fields-list-row').each(function() {
				initiateListRowState($(this));
			});
		}

		function initiateListRowState($fieldsListItem) {
			$fieldsListItem.find('.field').each(function() {
				$(this).prop('disabled', true);
			});
			$fieldsListItem.find('.fields-list-save-button').removeClass('fields-list-save-button').addClass('fields-list-edit-button').html(STAGE_TRANSLATION.EDIT);
			$fieldsListItem.find('.fields-list-delete-button').remove();

			$fieldsListItem.find('.timestamp-view-save').click();
		}

		function updateListValues($list) {
			$list.find('.fields-list-rows .fields-list-row .field:not(.timestamp-view-value):not(.timestamp-hours):not(.timestamp-minutes):not(.timestamp-timesetter)').each(function() {
				updateFieldValues($(this));
			});

			$list.data('last-num-rows', $list.data('current-num-rows') ||  0);
			$list.data('current-num-rows', $list.find('.fields-list-row:not(.empty-row)').length);

			updateListEntry($list);
		}

		/***
		 * Get field value from server
		 ***/
		function updateEntry($field) {
			if (typeof $field.data('uuid') === 'undefined' || $field.data('uuid') === '') {
				return;
			}

			var data = {
				turnaround: $('#field-turnaround').val(),
				attribute: $field.data('uuid'),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			startSync($field);
			$.get('/stage-ajax/entries', data).done(function(serverData) {
				stopSync($field);

				if (typeof serverData.value === 'undefined' || serverData.value === '') {
						// No value found on server. Feel free to save our own data.
					saveEntry($field);
					return;
				}

				if ($field.closest('.timestamp-container').length > 0) {
						// This is a timestamp type of field. Convert datetime string to unix timestamp.
						//var datetime = serverData.value.split(/[-: ]/);
						// month value below is between 0... 11, hence prefix decrement of month
						//serverData.value = Date.UTC(datetime[0], --datetime[1], datetime[2], datetime[3], datetime[4], datetime[5]);
				}

				var value = getValue($field);
				if ((typeof value === 'undefined' || value === '') && (typeof $field.data('last-value') === 'undefined' || $field.data('last-value') === '')) {
						// Server has a value, we don't. And we never had a value.
						// Feel free to insert server value in the field.
					setValue($field, serverData.value, serverData.uuid);

						// If timestamp, update timestamp stuff
					var $timestampContainer = $field.parents('.timestamp-container');
					if ($field.attr('type') === 'hidden' && $timestampContainer.length) {
							//console.log('updateEntry');
						updateTimestampView($timestampContainer);
					}

					checkAircraftType();

					return;
				}

				if (serverData.value == $field.data('last-value')) {
						// Previous value of this field before latest change is the same as the one on the server.
						// It was probably our entry, so feel free to overwrite it.
					saveEntry($field);
					return;
				}

					// TODO: Server has a value, we have a value, and our previous value is different from the server value.
					// This probably means that someone else has changed the value before us. Ask user if he wants to overwrite it.

				if (serverData.value != getValue($field)) {
						// Save new entry only if it changed
					saveEntry($field);
				} else {
					$field.parent().removeClass('error');
					$field.parent().find('.error-notification').remove();

				}
			})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if (jqXHR.status == 403) {
						showNotification('Please refresh page, your session has expired');
					}
					if (jqXHR.status !== 200) {
						stopSync($field);
						startOffline($field);
						offlineSaveEntry($field);
					}
				});
		}

		/***
		 * Get list values from server
		 ***/
		function updateListEntry($list) {
			if (typeof $list.data('uuid') === 'undefined' || $list.data('uuid') === '') {
				return;
			}

			var data = {
				turnaround: $('#field-turnaround').val(),
				list: $list.data('uuid'),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			startSync($list);
			$.get('/stage-ajax/listEntries', data).done(function(serverData) {
				stopSync($list);

				if (typeof serverData.values === 'undefined' || serverData.values.length === 0) {
					// No value found on server. Feel free to save our own data, if we have any.
					if ($list.data('current-num-rows') > 0) {
						saveListEntry($list);
					}
					return;
				}

				$.each(serverData.values, function(row, rowValues) {
					$.each(rowValues, function(col, value) {
						if (validDateTime.test(value)) {
							// This is a timestamp type of field. Convert datetime string to unix timestamp.
							//var datetime = value.split(/[-: ]/);
							// month value below is between 0... 11, hence prefix decrement of month
						}
						serverData.values[row][col] = value;
					});
				});
				//console.log('serverDataValues');
				//console.log(serverData.values);


				//var value = getValue($field);
				if (!($list.data('current-num-rows') > 0) &&
					!($list.data('last-num-rows') > 0)
				) {
					// Server has rows in this list, we don't. And we never had rows in this list.
					// Feel free to insert server rows in the list.
					setListValues($list, serverData.values);

					// If timestamp, update timestamp stuff
					var $timestampContainer = $list.find('.timestamp-container');
					$timestampContainer.each(function() {
						//console.log('updateListEntry');
						updateTimestampView($(this));
					});

					return;
				}

				// Note: userId is set in Stage (HTML-element > Sections / Turnaround selection)
				if (serverData.user == userId) {
					// Entry on the server was our entry, so feel free to overwrite it.
					saveListEntry($list);
					return;
				}

				// TODO: Server has a value, we have a value, and our previous value is different from the server value.
				// This probably means that someone else has changed the value before us. Ask user if he wants to overwrite it.

				if (JSON.stringify(serverData.values) != JSON.stringify(getListValues($list))) {
					// Save new entry only if it changed
					saveListEntry($list);
				}
			}).fail(function(jqXHR, textStatus, errorThrown) {
				if (jqXHR.status !== 200) {
					stopSync($list);
					startOffline($list);
				}
			});
		}


		/***
		 * Save entry to database.
		 ***/
		function saveEntry($field) {
			if ($field.closest('.fields-list').length > 0) {
				// This is an attribute in a list. use saveListEntry function.
				return false;
			}

			var data = {
				turnaround: $('#field-turnaround').val(),
				attribute: $field.data('uuid'),
				value: getValue($field),
				age: Math.round((Date.now() - $field.data('change-time')) / 1000),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			if ((typeof data.value !== 'undefined' && data.value !== '') || (typeof $field.data('last-value') !== 'undefined' && $field.data('last-value') !== '')) {

				if ($field.closest('.timestamp-container').length > 0) {
					// This is a timestamp type of field. Convert value to date string.
					var dataValue = 0;

					if (!isNaN(data.value) && data.value !== '') {
						dataValue = data.value;
					}

					//data.value = new Date(parseInt(dataValue)).toISOString().replace('T', ' ').substring(0, 19);
				}

				stopOffline($field);

				$.post('/stage-ajax/entry', data).done(function(serverData) {
						// TODO: on successfull save receive timestamp and set it to data attribute
					$field.data('change-time', false);
					$field.parent().removeClass('error');
					$field.parent().find('.error-notification').remove();

					$field.parent().addClass('saved-successfully');
					setTimeout(function(){
						$field.parent().removeClass('saved-successfully');
					}, 1500);
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if (jqXHR.status == 403) {
						showNotification('Please refresh page, your session has expired');
					}

					if (jqXHR.status != 200 && jqXHR.status != 400) {
						startOffline($field);
						window.localEntries.push(data);
					} else if (jqXHR.status == 400) {

						showNotification('invalid entry, not saved');
						// TODO: show on the field that things went wrong and old value returned

						//setValue($field, $field.data('last-value'));

						$field.parent().addClass('error');
						$field.parent().append('<div class="error-notification">' + jqXHR.responseText + '</div>');

						$field.data('current-value', $field.data('last-value'));
					}
				});
			}
		}

		/***
		 * Save entry for offline use.
		 ***/
		function offlineSaveEntry($field) {

			if ($field.closest('.fields-list').length > 0) {
				// This is an attribute in a list. use saveListEntry function.
				return false;
			}

			if (!window.localEntries.hasOwnProperty($('#field-turnaround').val())) {
				window.localEntries[$('#field-turnaround').val()] = {};
			}

			window.localEntries[$('#field-turnaround').val()][$field.data('uuid')] = {
				turnaround: $('#field-turnaround').val(),
				attribute: $field.data('uuid'),
				value: getValue($field),
				age: Math.round((Date.now() - $field.data('change-time')) / 1000),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			localStorage.setItem(window.userId, JSON.stringify(window.localEntries));
		}

		function saveListEntry($list) {
			var data = {
				turnaround: $('#field-turnaround').val(),
				list: $list.data('uuid'),
				values: getListValues($list),
				age: Math.round((Date.now() - $list.data('change-time')) / 1000),
				clientJSVersion: clientJSVersion,
				'stage-language': 'en'
			};

			stopOffline($list);

			//console.log(data);
			$.post('/stage-ajax/listEntry', data)
				.done(function(serverData) {
					// TODO: on successfull save receive timestamp and set it to data attribute
					$list.data('change-time', false);
				})
				.fail(function(jqXHR, textStatus, errorThrown) {
					if (jqXHR.status != 200 && jqXHR.status != 400) {
						startOffline($list);
					} else if (jqXHR.status == 400) {
						showNotification('invalid entry, not saved');
						// TODO: show on the field that things went wrong and old value returned
						//setValue($field, $field.data('last-value'));
						//$field.data('current-value', $field.data('last-value'));
					}
				});
		}

		function updateTimestampView($timestampContainer) {
			if (typeof $timestampContainer === 'undefined') {
				$('.timestamp-container').each(function() {
					updateTimestampView($(this));
				});
				return;
			}

			var $target = $($timestampContainer.data('target'));

			// Timestamp has value
			if ($target.val() !== '' && $target.val() !== 0 && $target.val() !== '0') {

				if ($timestampContainer.hasClass('editing')) {
					return;
				}

				var timestamp = $target.val();
				//console.log('updateTimeStampView value: ' + timestamp);

				//var timestampText = leftpad(timestamp.getUTCHours()) + ':' + leftpad(timestamp.getUTCMinutes());
				var timestampText = timestamp;
				$timestampContainer.find('.timestamp-view-value').html(timestampText);
				//$timestampContainer.find('.timestamp-timesetter').val(timestampText);
				//$timestampContainer.find('.timestamp-hours').val(timestamp.getUTCHours());
				//$timestampContainer.find('.timestamp-minutes').val(timestamp.getUTCMinutes());

				// In list / add-row, don't show view. Show only setter.
				if ($target.closest('.fields-list-add').length > 0) {
					$timestampContainer.children('.timestamp-setter').hide();
					$timestampContainer.children('.timestamp-change').show();
					$timestampContainer.children('.timestamp-view').hide();
				} else {
					// Hide timestamp setters, show timestamp view and change
					$timestampContainer.children('.timestamp-setter').hide();
					$timestampContainer.children('.timestamp-change').hide();
					$timestampContainer.children('.timestamp-view').show();
				}

			} else {

				if (currentTurnaround.arrTime < new Date() && currentTurnaround.depTime > new Date()) {
					// Timestamp has not yet been set at all. Show quick setter if turnaround is ongoing.
					//$timestampContainer.children('.timestamp-setter').show();
					$timestampContainer.children('.timestamp-view').hide();
					$timestampContainer.children('.timestamp-change').show();

				} else {
					// Turnaround is not ongoing. Show timestamp free set instead of NOW button
					// This will halt the autosync because timestamp field is being edited
					// But that's ok, this is not an ongoing turnaround, it's probably being updated
					// by only one person at a time. Sync probably not necessary.
					$timestampContainer.children('.timestamp-setter').hide();
					$timestampContainer.children('.timestamp-change').show();
					$timestampContainer.children('.timestamp-view').hide();
				}

			}
		}

		/***
		 * Update list data
		 *
		 * When adding/deleting rows, each row needs to
		 * make sure their uuid:s, names, etc. are up to date.
		 ***/
		function updateListRows($list) {
			var listValues = getListValues($list);
			setListValues($list, listValues);
		}


		function createFlights() {
			// Send create flights form
			var $form = $('#create-flights-form'),
				data = {},
				$submit = $('#create-flights-submit'),
				$error = $('#create-flights .error');

			$error.empty();

			// ac-reg, arr-fltnr, dep-fltnr, arr-from, dep-to
			$form.find('.field').each(function() {
				data[$(this).attr('name')] = $(this).val();
			});

			// arr-sdt, dep-sdt
			data['arr-sdt'] = $form.find('[name="arr-sdt-date"]').val() + ' ' + $form.find('[name="arr-sdt-time"]').val();
			data['dep-sdt'] = $form.find('[name="dep-sdt-date"]').val() + ' ' + $form.find('[name="dep-sdt-time"]').val();

			if (data['arr-sdt'] >= data['dep-sdt']) {
				showNotification('Departure must be later than arrival!');
				return;
			}

			data.airport = airport;
			data.clientJSVersion = clientJSVersion;
			data['stage-language'] = 'en';

			$submit.prop('disabled', true).data('original-html', $submit.html()).html(STAGE_TRANSLATION.CREATING);

			$.post('/stage-ajax/createFlights', data).done(function(serverData) {
				stopOffline($form);

				//console.log(serverData);

				if (typeof serverData.turnaround === 'object' && typeof serverData.turnaround.turnaround !== 'undefined') {
					// New turnaround was created successfully. Add it to turnarounds list and switch to it.

					//console.log(' New turnaround was created successfully. Add it to turnarounds list and switch to it. ');

					turnarounds[serverData.turnaround.turnaround] = serverData.turnaround;
					var $turnaround = $('#field-turnaround');
					$turnaround.append('<option value="' + serverData.turnaround.turnaround + '">' + serverData.turnaround.title + '</option>');
					$turnaround.val(serverData.turnaround.turnaround);

					//console.log(' New turnaround value: ' + serverData.turnaround.turnaround);

					selectTurnaround();
				}

				if (serverData.errors.length > 0) {
					var $errorUl = $('<ul>');
					for (var i = 0; i < serverData.errors.length; i++) {
						$errorUl.append('<li>' + serverData.errors[i] + '</li>');
					}
					$error.append($errorUl);
				}
				$submit.prop('disabled', false).html($submit.data('original-html'));

			}).fail(function(jqXHR, textStatus, errorThrown) {
				var errortext;
				if (jqXHR.status !== 200) {
					startOffline();
					errortext = STAGE_TRANSLATION.NETWORK_ERROR + ' (' + jqXHR.status + ': ' + textStatus + ')';
				} else {
					errortext = STAGE_TRANSLATION.UNKNOWN_ERROR;
				}
				var $errorP = $('<p>');
				$errorP.html(errortext);
				$error.append($errorP);

				$submit.prop('disabled', false).html($submit.data('original-html'));
			});
		}


		function setValue($field, value, entryUuid = false) {
			// Sets field value, or in case of a radio button, checks the correct value

			if($field) {

				if (entryUuid) {
					//console.log(JSON.stringify($field.attr('name')) + ' ' + ' entryUuid:'+entryUuid);
					$field.attr('data-entry-uuid', entryUuid);
				}

				if ($field.length > 1) {
					$field.each(function() {
						setValue($(this), value);
					});
					return true;
				}

				// Radio button
				if ($field.is('input[type="radio"]')) {
					if ($field.val() === value) {
						$field.prop('checked', true);
					} else {
						$field.prop('checked', false);
					}

					return true;
				}

				// Timestamp
				var $timestampContainer = $field.closest('.timestamp-container');
				if ($timestampContainer.length > 0) {
					if ($timestampContainer.hasClass('editing')) {
						return true;
					}

					if (validDateTime.test(value)) {
						//console.log('valid date');
						//value = '';

						$field.val(value);
						updateTimestampView($timestampContainer);
						//console.log('setValue timestamp: ' + value);
					}
					if (value == '') {
						$field.val('');
						updateTimestampView($timestampContainer);

					}

					return true;
				}

				var $listContainer = $field.closest('.fields-list');
				if ($listContainer.length > 0) {
					//console.log('setValue');
					//console.log(value);


					if ($listContainer.hasClass('editing')) {
						//console.log($listContainer);

						return true;
					}

				}


				// Other input (text, number, select)
				$field.val(value);

				return true;

			}
		}


		function setListValues($list, values, entryUuid = false) {

			if ($list.length > 1) {
				$list.each(function() {
					setListValues($(this), values, entryUuid);
				});

				return;
			}
			// Sets values for the whole list

			//console.log('setListValues');

			if ($list.hasClass('editing')) {
				//console.log('setListValues has class editing');
				//return;
			}

			$list.find('.fields-list-rows .fields-list-row').each(function() {
				var $row = $(this);
				var row = $(this).index();
				var rowIsEmpty = true;

				$row.find('.fields-list-col').each(function() {
					var $col = $(this);
					var col = $(this).index();
					var $field = $col.find('.field:not(.timestamp-view-value):not(.timestamp-hours):not(.timestamp-minutes):not(.timestamp-timesetter)');

					if (typeof values[row] !== 'undefined' && typeof values[row][col] !== 'undefined' && values[row][col] !== '') {
							// Value for this row and col exists. Insert it.
						var euuid = entryUuid ? entryUuid[row][col] : false;
						setValue($field, values[row][col], euuid);
						rowIsEmpty = false;
					} else {
						setValue($field, '');
					}
				});

				$row.toggleClass('empty-row', rowIsEmpty);
			});

		}

		function getValue($field) {
			// Gets field value correctly in all cases (radio button, select or any other input)

			// Radio button
			if ($field.is('input[type="radio"]')) {
				var $checkedField = $('input[name="' + $field.attr('name') + '"]:checked');
				if ($checkedField.length) {
					return $checkedField.val();
				}
				return false;
			}

			// Select or other input type
			return $field.val();
		}

		function getListValues($list) {
			// Gather values from list rows
			var values = [];

			$list.find('.fields-list-rows .fields-list-row:not(.empty-row)').each(function() {
				var row = [];

				//console.log($(this));
				$(this).find('.fields-list-col .field:not(.timestamp-view-value):not(.timestamp-hours):not(.timestamp-minutes):not(.timestamp-timesetter):not(.timestamp-datesetter)').each(function() {
					var $field = $(this);
					//console.log($field);
					var value = getValue($field);

					if ($field.closest('.timestamp-container').length > 0) {
						// This is a timestamp type of field. Convert value to date string.
						var dataValue = 0;

						if (!isNaN(value) && value !== '') {
							dataValue = value;
						}

						//value = new Date(parseInt(dataValue)).toISOString().replace('T', ' ').substring(0, 19);
					}

					row.push(value);
				});

				values.push(row);
			});
			//console.log(values);
			return values;
		}

		function startSync($field) {
			stopOffline();
			var $timestampContainer = $($field).closest('.timestamp-container');
			if ($timestampContainer.length > 0) {
				$timestampContainer.addClass('syncing');
			} else {
				$field.addClass('syncing');
			}
			updateSyncing();
		}

		function stopSync($field) {
			var $timestampContainer = $($field).closest('.timestamp-container');
			if ($timestampContainer.length > 0) {
				$timestampContainer.removeClass('syncing');
			} else {
				$field.removeClass('syncing');
			}
			updateSyncing();
		}

		function updateSyncing() {
			if ($('.syncing').length > 0) {
				$('.sync-indicator').removeClass('not-syncing');
				$('#sync-button, #field-turnaround').prop('disabled', true);
				return;
			}

			$('#sync-button').prop('disabled', false);
			$('.sync-indicator').addClass('not-syncing');

			if (!$('body').hasClass('offline')) {
				$('#field-turnaround').prop('disabled', false);
			}
		}

		function startOffline($field) {
			$('body').addClass('offline');
			$('#field-turnaround').prop('disabled', true);
			if (typeof $field !== 'undefined') {
				$field.addClass('offline');
			}
		}

		function stopOffline($field) {
			$('body').removeClass('offline');
			$('#field-turnaround').prop('disabled', false);
			if (typeof $field !== 'undefined') {
				$field.removeClass('offline');
			}
		}

		function leftpad(string, length, char) {
			if (typeof string === 'undefined') {
				return '';
			}
			if (typeof length === 'undefined') {
				length = 2;
			}
			if (typeof char === 'undefined') {
				char = '0';
			}

			var twoDigitNumber = '' + string; // in case string is an integer

			// Add char to the beginning of string until it's long enough
			while (twoDigitNumber.length < length) {
				twoDigitNumber = char + twoDigitNumber;
			}

			return twoDigitNumber;
		}

		function toAttr(str) {
			if (typeof str !== 'string') {
				return str;
			}
			return str.replace(/[^A-z0-9]/, '-').toLowerCase();
		}

		// Check if Aircraft Type field is not empty. If it is, warn user.
		function checkAircraftType() {
			var $field = $('[data-uuid="t5kg633OTYmUjeHkY8Fr3w"]');
			var value = getValue($field);
			$field.closest('.section-fields').toggleClass('warning', typeof value !== 'string' || value === '');
		}

		function updateFlightTimes() {
			var turnaround = $('#field-turnaround').val();
			if (turnaround && turnaround !== 'turnaround_not_on_list') {
				$.get(
					'/stage-ajax/times', {
						turnaround: turnaround,
						clientJSVersion: clientJSVersion,
						'stage-language': 'en'
					},
					function(data) {
						var
							dt,
							time,
							fields = {
								arr: {
									sdt: 'arr_sdt',
									est: 'arr_est',
									act: 'arr_act',
									blk: 'arr_blk'
								},
								dep: {
									gtg: 'calls_1',
									bor: 'calls_2',
									fin: 'calls_3',
									gtc: 'calls_4',
									sdt: 'dep_sdt',
									est: 'dep_est',
									act: 'dep_act',
									blk: 'dep_blk'
								}
							};
						for (var ad in fields) {
							for (var prop in fields[ad]) {
								if (data[ad][prop]) {
									dt = new Date(data[ad][prop].substring(0, 16).replace(/(\d) (\d)/, '$1T$2') + 'Z');
									dt.setTime(dt.getTime() + (new Date().getTimezoneOffset() * -1 * 60 * 1000));
									time = dt.toISOString().substring(11, 16);

									$('span[data-property="' + fields[ad][prop] + '"]').text(time);
								} else {
									$('span[data-property="' + fields[ad][prop] + '"]').text('');
								}
							}
						}
						currentTurnaround.arrTime = (data.arr.act || data.arr.est || data.arr.sdt);
						currentTurnaround.depTime = (data.dep.act || data.dep.est || data.dep.sdt);
						if (currentTurnaround.arrTime) {
							currentTurnaround.arrTime = new Date(currentTurnaround.arrTime.replace(' ', 'T') + 'Z');
						}
						if (currentTurnaround.depTime) {
							currentTurnaround.depTime = new Date(currentTurnaround.depTime.replace(' ', 'T') + 'Z');
						}
					}
				);
			}
		}

		function updateNils() {
			var t = $('#field-turnaround').val();

			if (t) {
				$.get(
					'/stage-ajax/nil/?turnaround=' + t + '&clientJSVersion=' + clientJSVersion + '&stage-language=en',
					function(data) {
						$('.fields-list').each(function() {
							var
								$t = $(this),
								uuid = $t.attr('data-uuid'),
								$i = $t.find('.nil-setter input');

							$i.prop('checked', data.indexOf(uuid) !== -1);
							// disable NIL-inputs for non-empty lists
							/* I commented this out because it was causing problems. -ZS 2017-12-07
							if ($t.find('.fields-list-row').not('.empty-row').length) {
								$i.prop('disabled', true);
							}
							*/
						});

						disableNilLists();
					});
			}
		}

		function disableNilLists() {
			return; // Turns out we don't want to do this. Instead if user adds a row, Nil will be unchecked automatically.
			$('.fields-list').each(function() {
				var
					$t = $(this),
					nilled = !!$t.find('.nil-setter input').prop('checked');

				$t.find('.fields-list-add').find('button, input').prop('disabled', nilled);
			});
		}

		function showNotification(msg) {
			var $notification = $('body > .notification');
			$notification.find('.notification-message').text(msg);
			$notification.removeClass('hidden');
			setTimeout(function() {
				$notification.addClass('hidden').find('.notification-message').empty();
			}, 10000);
		}

		function querystringToObj(key) {
			var
				search = location.search.substring(1),
				obj = JSON.parse(
					'{"' +
					decodeURI(search)
					.replace(/"/g, '\\"')
					.replace(/&/g, '","')
					.replace(/=/g, '":"') +
					'"}');
			return key ? obj[key] : obj;
		}

	}

};

module.exports = serviceCard;
